import React from 'react'
import { pure } from 'recompose'
import PropTypes from 'prop-types'
import * as Types from 'types'
import CommunityImage from './community-image'

const propTypes = {
  logos: PropTypes.arrayOf(Types.image).isRequired,
}

const defaultProps = {}

function MultipleLogoBlock({ logos }) {
  return (
    <div className="logo-block multiple-logo-block">
      {logos.map((logo) => {
        return (
          <div key={logo.src} className="logo-block-item">
            <CommunityImage image={logo} />
          </div>
        )
      })}
    </div>
  )
}

MultipleLogoBlock.propTypes = propTypes
MultipleLogoBlock.defaultProps = defaultProps

export default pure(MultipleLogoBlock)
